import React from "react";
import { Button, Input } from "reactstrap";
import "./styles/fieldsEditor.scss";

function FieldsEditor({ fields = [], onChange }) {
  const handleAddField = () => {
    const newFields = [...fields, { name: "" }];
    onChange(newFields);
  };

  const handleRemoveField = (index) => {
    const newFields = fields.filter((_, idx) => idx !== index);
    onChange(newFields);
  };

  const handleFieldNameChange = (index, newName) => {
    const newFields = [...fields];
    newFields[index] = { ...newFields[index], name: newName };
    onChange(newFields);
  };

  const handleReorderField = (fromIndex, toIndex) => {
    const newFields = [...fields];
    const [removed] = newFields.splice(fromIndex, 1);
    newFields.splice(toIndex, 0, removed);
    onChange(newFields);
  };

  return (
    <div className="fields-editor">
      {fields.length === 0 ? (
        <div className="empty-state">
          <i className="fas fa-inbox" />
          <p>No fields defined yet</p>
          <small className="text-muted">Click "Add Field" to get started</small>
        </div>
      ) : (
        <div className="fields-list">
          {fields.map((field, index) => (
            <div key={index} className="field-item">
              <div className="field-number">{index + 1}</div>

              <Input
                type="text"
                value={field.name || ""}
                onChange={(e) => handleFieldNameChange(index, e.target.value)}
                placeholder={`Field ${index + 1} name (e.g., Invoice Number, Date, Amount)`}
                className="field-input"
              />

              <div className="field-actions">
                {index > 0 && (
                  <Button
                    size="sm"
                    color="secondary"
                    onClick={() => handleReorderField(index, index - 1)}
                    title="Move up"
                  >
                    <i className="fas fa-chevron-up" />
                  </Button>
                )}

                {index < fields.length - 1 && (
                  <Button
                    size="sm"
                    color="secondary"
                    onClick={() => handleReorderField(index, index + 1)}
                    title="Move down"
                  >
                    <i className="fas fa-chevron-down" />
                  </Button>
                )}

                <Button
                  size="sm"
                  color="danger"
                  onClick={() => handleRemoveField(index)}
                  title="Delete field"
                >
                  <i className="fas fa-trash" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}

      <Button
        color="success"
        outline
        onClick={handleAddField}
        className="add-field-btn"
      >
        <i className="fas fa-plus" /> Add Field
      </Button>
    </div>
  );
}

export default FieldsEditor;
